import { useMemo } from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Filler } from "chart.js";
import { CardHeader, NoDataFound } from "./Common";

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Filler);

export default function TrendChart({ title, subtitle, data }) {
  const chartData = useMemo(
    () => ({
      labels: (data || []).map((d) => d.bucket),
      datasets: [
        {
          data: (data || []).map((d) => d.total),
          borderColor: "#38bdf8",
          backgroundColor: (ctx) => {
            const { chart } = ctx;
            const { ctx: canvasCtx, chartArea } = chart;
            if (!chartArea) return "rgba(56, 189, 248, 0.15)";
            const gradient = canvasCtx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
            gradient.addColorStop(0, "rgba(56, 189, 248, 0.25)");
            gradient.addColorStop(1, "rgba(56, 189, 248, 0)");
            return gradient;
          },
          fill: true,
          tension: 0.35,
          pointRadius: 2.5,
          pointHoverRadius: 5,
          pointBackgroundColor: "#38bdf8",
          borderWidth: 2,
        },
      ],
    }),
    [data]
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#1f2937",
        titleFont: { size: 11 },
        bodyFont: { size: 11 },
        padding: 8,
        displayColors: false,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#9ca3af", font: { size: 10 }, maxRotation: 0, autoSkip: true, maxTicksLimit: 8 },
      },
      y: {
        beginAtZero: true,
        grid: { color: "#f1f5f9" },
        ticks: { color: "#9ca3af", font: { size: 10 }, precision: 0 },
      },
    },
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4 flex flex-col">
      <CardHeader title={title} subtitle={subtitle} />

      {!data?.length ? (
        <NoDataFound label="No activity in this period" />
      ) : (
        <div className="h-44">
          <Line data={chartData} options={options} />
        </div>
      )}
    </div>
  );
}
